export default __webpack_public_path__ + "static/media/slide5.3a1dc590.jpeg";